import ProfileLayout from '../modules/Profile/ProfileLayout';
import CreditCards from '../modules/Profile/CreditCards';
import { CustomNextPage } from '../lib/types';
import { PROFILE_PAGE_QUERY } from '../modules/Profile/graphql';
import { profilePageQuery } from '../core-types';
import { bootstrap } from '../lib/bootstrap';

const CreditCardsPage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  return (
    <ProfileLayout url={url} statusCode={statusCode}>
      {({ currentUser }) => {
        if (!currentUser) {
          return null;
        }
        return <CreditCards />;
      }}
    </ProfileLayout>
  );
};

CreditCardsPage.getInitialProps = async ctx => {
  const profilePageQueryResult = await ctx.apolloClient.query<profilePageQuery>(
    {
      query: PROFILE_PAGE_QUERY
    }
  );
  let statusCode;
  if (!profilePageQueryResult.data?.profilePage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode
  };
};

export default bootstrap(CreditCardsPage);
